export default __webpack_public_path__ + "static/logo-da90f26afa5470a8f0d76d66ebe6bc21.png";